import { atom } from "recoil";

export const LoginActiveView = atom({
  key: "loginActiveView",
  default: "login",
});
